export default __webpack_public_path__ + "static/logo-header-12dbf7deaad7c595ef157e3415a747b4.svg";